import styled from '@emotion/styled';
import { GeneralFormError } from '@ui-components/neo.tax';

export const ModalContainer = styled.div({
  maxWidth: '540px',
});

export const GeneralFormErrorStyled = styled(GeneralFormError)({
  textAlign: 'left',
});
